import { createSelector } from '@reduxjs/toolkit';

export const getSurveys = (state) => state.surveys;

export const getActiveSurvey = createSelector(getSurveys, (surveys) =>
    surveys.find(({ active }) => active)
);
